<div class="relative flex items-center w-full">
  <div
    class="cursor-pointer flex justify-center items-center rounded-[5px] size-[40px] bg-brand-light mr-2"
    (click)="onIconClick($event)"
  >
    <!-- font-awesome icon -->
    @if (faIcon !== null) {
      <fa-icon class="text-[15px] text-brand" [icon]="faIcon"></fa-icon>
    } @else {
      <img class="w-[15px] h-[15px] legacy-icon" [src]="legacyIconUrl" alt="icon" />
    }
    <!-- legacy icon -->
  </div>
  <div class="flex-1">
    <rk-form-field [showError]="pageNameControl?.invalid && pageNameControl?.touched">
      @if (pageNameControl) {
        <input
          class="bg-[#f7f7f7] px-4 py-2 rounded-[5px]"
          [class.form-alert]="pageNameControl?.invalid && pageNameControl?.touched"
          [formControl]="pageNameControl"
          maxlength="45"
        />
      }
    </rk-form-field>
  </div>

  @if (iconSearchVisible) {
    <rk-icon-search
      #iconSearch
      class="absolute left-[-8px] top-[24px] z-10 icon-search"
      (iconSelected)="onIconSelected($event)"
    ></rk-icon-search>
  }
</div>
